import styled from 'styled-components';
import { Switch } from 'antd';

export const PageWrapper = styled.div`
  padding: 0;
`;

export const TableWrapper = styled.div`
  margin-top: 16px;
`;

export const ItemNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ItemThumbnailWrap = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
`;

export const ThumbnailImg = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
`;

export const NoImagePlaceholder = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: #f5f5f5;
  border: 1px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c0c0;
  flex-shrink: 0;
`;

export const BadgeOverlay = styled.img`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 22px;
  height: 22px;
  object-fit: contain;
  pointer-events: none;
  z-index: 2;
`;

export const ItemEyeBadge = styled.div`
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #7c3aed;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 1;
`;

export const PreviewImageWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const PreviewBadgeOverlay = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 80px;
  object-fit: contain;
  pointer-events: none;
  z-index: 2;
`;

export const PreviewImg = styled.img`
  max-width: 80vw;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
`;

export const ItemNameText = styled.span`
  font-weight: 600;
`;

export const DescriptionText = styled.span`
  color: #888;
  font-size: 13px;
`;

export const StatusTag = styled.span<{
  $variant: 'price' | 'yes-green' | 'yes-blue' | 'no';
  $isDark: boolean;
}>`
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  ${({ $variant, $isDark }) => {
    switch ($variant) {
      case 'price':
        return $isDark
          ? 'background:rgba(251,191,36,0.12);border:1px solid rgba(251,191,36,0.3);color:#fbbf24;'
          : 'background:#fff7e6;border:1px solid #ffd591;color:#d46b08;';
      case 'yes-green':
        return $isDark
          ? 'background:rgba(52,211,153,0.12);border:1px solid rgba(52,211,153,0.3);color:#34d399;'
          : 'background:#f6ffed;border:1px solid #b7eb8f;color:#389e0d;';
      case 'yes-blue':
        return $isDark
          ? 'background:rgba(96,165,250,0.12);border:1px solid rgba(96,165,250,0.3);color:#60a5fa;'
          : 'background:#e6f7ff;border:1px solid #91d5ff;color:#0958d9;';
      case 'no':
        return $isDark
          ? 'background:rgba(156,163,175,0.08);border:1px solid rgba(156,163,175,0.2);color:#6b7280;'
          : 'background:#fafafa;border:1px solid #d9d9d9;color:#8c8c8c;';
    }
  }}
`;

export const SoldOutSwitchWrap = styled.div<{ $busy: boolean }>`
  display: inline-block;
  cursor: ${({ $busy }) => ($busy ? 'not-allowed' : 'pointer')};
`;

export const SoldOutSwitch = styled(Switch).withConfig({
  shouldForwardProp: (prop) => prop !== '$soldOut',
})<{ $soldOut?: boolean }>`
  ${({ $soldOut }) => $soldOut && 'background: #ff4d4f !important;'}

  .ant-switch-inner .ant-switch-inner-checked,
  .ant-switch-inner .ant-switch-inner-unchecked {
    color: #fff !important;
  }
`;
